var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.isShow)?_c('com-header',{style:({backgroundColor:_vm.opacity})}):_c('com-H5-Header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('com-footer'),_vm._v(" "),_c('com-float',{attrs:{"show":_vm.flag},on:{"gotop":_vm.gotop}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e39cb69c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 